import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { OrgStructureSupplierComponent } from './org-structure-supplier.component';

const routes: Routes = [
  {
    path: '',
    component: OrgStructureSupplierComponent,
    data: { title: 'Manage Organisation Structure' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrgStructureSupplierRoutingModule {}

@NgModule({
  imports: [
    OrgStructureSupplierRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [OrgStructureSupplierComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrgStructureSupplierModule {}
